import { cardItems } from '@/mocks/homeData';

export default function Cards() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新爆料</h2>
            <p className="mt-2 text-sm text-foreground-500">每日滚动更新的网红黑料情报，不错过任何一个瓜</p>
          </div>
          <span className="hidden sm:flex items-center gap-1.5 text-xs text-accent-600 font-medium whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="group bg-background-100/80 rounded-xl border border-background-200/60 hover:border-primary-200/50 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 md:h-52 object-cover transition-transform duration-500 group-hover:scale-105"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 text-xs font-semibold bg-primary-500 text-white px-2 py-0.5 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                  <span>{item.time}</span>
                  <span className="flex items-center gap-1 text-primary-600 font-medium">
                    <i className="ri-fire-line"></i> {item.hot}热度
                  </span>
                </div>
              </div>
            </div>
          ))}

          {cardItems.slice(3).map((item, i) => (
            <div
              key={i + 3}
              className="group bg-background-100/80 rounded-xl border border-background-200/60 hover:border-primary-200/50 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 md:h-52 object-cover transition-transform duration-500 group-hover:scale-105"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 text-xs font-semibold bg-secondary-500 text-white px-2 py-0.5 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                  <span>{item.time}</span>
                  <span className="flex items-center gap-1 text-primary-600 font-medium">
                    <i className="ri-fire-line"></i> {item.hot}热度
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}